// @flow

import * as React from 'react';

import type { TranslatorProps } from '@gandi/translate';

import type { FormComponentProps } from 'gandi.react-form';

import type { WithRouterProps } from '../../../../../helpers/withRouter';
import { getSetupOverviewUrl } from '../../../modules/helpers';
import type { CreateOrTransfer, EditableRole } from '../../../types';
import ContactForm, { visitFormNodes } from '../ContactForm';
import { formSection2, getContactFields } from '../helpers';
import type { FormValues } from '../types';

export type StateProps = {
  // used in index/onSubmit
  // eslint-disable-next-line react/no-unused-prop-types
  orgId: string,

  cartId: string,
  formValues: FormValues,

  // to override `initialValues` of `gandi.react-form`
  // eslint-disable-next-line react/no-unused-prop-types
  initialValues: FormValues,

  isWorking: boolean,
};

type InjectedProps = {
  ...WithRouterProps<>,
  formProps: FormComponentProps,
};

export type OwnProps = {
  // `role`, `router`, used in index/onSubmit
  // eslint-disable-next-line react/no-unused-prop-types
  role: EditableRole,

  process: CreateOrTransfer,
  canWriteContactBook: boolean,
  translator: TranslatorProps,
};

export type Props = {
  ...OwnProps,
  ...StateProps,
  ...InjectedProps,
};

const Presenter = ({
  formValues,
  formProps,
  cartId,
  canWriteContactBook,
  translator,
  isWorking,
  process,
}: Props): React.Node => {
  const { __ } = translator;

  // Good candidate to memoization.
  const fields = getContactFields(translator);

  // Describes how the form will be displayed
  const formView = {
    name: 'form__root',
    type: 'form__root',
    children: [formSection2],
  };

  // In each form node, use the fields as default values.
  let decoratedFormView = visitFormNodes(formView, node => ({
    ...fields.find(field => field.name === node.name),
    ...node,
  }));

  // Do not show the organization name field for contacts of type individual.
  if (formValues?.type === 'individual') {
    decoratedFormView = visitFormNodes(decoratedFormView, node =>
      'children' in node
        ? {
            ...node,
            children: node.children.filter(child => child.name !== 'orgname'),
          }
        : node,
    );
  }

  return (
    <ContactForm
      canWriteContactBook={canWriteContactBook}
      formProps={formProps}
      formView={decoratedFormView}
      cancelUrl={getSetupOverviewUrl(cartId, process)}
      cancelLabel={__('Cancel')}
      submitLabel={__('Create')}
      isWorking={isWorking}
    />
  );
};

export default Presenter;
